// tippi/src/pages/carrier/AssignPanel.js
import React, { useState } from 'react';
import { carrierApi } from '../../firebase/functionsService';
import { vehicleAvailability } from '../../utils/vehicleStatus';
import { canReassign } from '../../utils/carrierOrderStatus';
import Field from './Field';
import { ui } from './carrierStyles';

// Tildeling av en egen ordre: velg aktiv sjåfør og tilgjengelig bil, eller trekk tilbake.
// Serveren (offerCarrierOrder) sjekker alt på nytt. Sjåføren må godta før ordren er tildelt.
export default function AssignPanel({ orgId, order, members, vehicles, onDone }) {
  const drivers = members.filter(m => m.role === 'driver' && m.status === 'active');
  const assignedUid = order.offeredToUid ?? order.driverUid ?? '';
  const assignedVehicleId = order.offeredVehicleId ?? order.vehicleId ?? '';
  const [driverUid, setDriverUid] = useState('');
  const [vehicleId, setVehicleId] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const nameOf = (uid) => members.find(m => m.id === uid)?.name ?? 'sjåføren';
  const plateOf = (id) => vehicles.find(v => v.id === id)?.registrationPlate ?? 'bilen';

  let current = 'Ikke tildelt ennå.';
  if (order.status === 'offered') current = `Venter på svar fra ${nameOf(assignedUid)} (${plateOf(assignedVehicleId)}).`;
  else if (assignedUid) current = `Tildelt ${nameOf(assignedUid)} med ${plateOf(assignedVehicleId)}.`;

  function pickDriver(e) {
    const uid = e.target.value;
    setDriverUid(uid);
    // Foreslå sjåførens standardbil hvis den er tilgjengelig
    const suggested = vehicles.find(v => v.defaultDriverUid === uid && vehicleAvailability(v).ok);
    if (uid && suggested) setVehicleId(suggested.id);
  }

  async function send(input) {
    setStatus('saving');
    setMessage('');
    try {
      await carrierApi.offerCarrierOrder({ orgId, orderId: order.id, ...input });
      setStatus('idle');
      setDriverUid('');
      setVehicleId('');
      if (onDone) onDone();
    } catch (err) {
      setStatus('error');
      setMessage(err.message || 'Kunne ikke tildele ordren');
    }
  }

  if (!canReassign(order.status)) return <p style={{ margin: 0 }}>{current}</p>;

  const assigned = order.status === 'offered' || order.status === 'matched';

  return (
    <div>
      <p style={{ margin: '0 0 8px' }}>{current}</p>
      <div style={ui.row}>
        <Field id="a-driver" label="Sjåfør" style={{ flex: 1, minWidth: 180 }}>
          <select id="a-driver" style={ui.input} value={driverUid} onChange={pickDriver}>
            <option value="">Velg sjåfør</option>
            {drivers.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
          </select>
        </Field>
        <Field id="a-vehicle" label="Bil" style={{ flex: 1, minWidth: 180 }}>
          <select id="a-vehicle" style={ui.input} value={vehicleId} onChange={e => setVehicleId(e.target.value)}>
            <option value="">Velg bil</option>
            {vehicles.map(v => {
              const availability = vehicleAvailability(v);
              return (
                <option key={v.id} value={v.id} disabled={!availability.ok}>
                  {`${v.registrationPlate} (${availability.label})`}
                </option>
              );
            })}
          </select>
        </Field>
      </div>
      {status === 'error' && <p role="alert" style={ui.error}>{message}</p>}
      <div style={{ ...ui.row, marginTop: 14 }}>
        <button type="button" className="tippi-btn" style={ui.btn} disabled={!driverUid || !vehicleId || status === 'saving'}
                onClick={() => send({ driverUid, vehicleId })}>
          {assigned ? 'Tilby til ny' : 'Tilby ordren'}
        </button>
        {assigned && (
          <button type="button" style={ui.btnSecondary} disabled={status === 'saving'}
                  onClick={() => send({ driverUid: null, vehicleId: null })}>
            Trekk tilbake
          </button>
        )}
      </div>
    </div>
  );
}
